import  mensajeError  from "../mensajes/MensajeError";


export const crearPoliza = async (data, nuevoTramite, vigencia, observaciones, anualidad, aPagar) => {
    const concesionario = data.concesionActual;
    const direccion = data.direcciones[0] ?? [];
    const contribuyente = data.contribuyente;

    const datosAdicionales =
        `Autorización: ${concesionario.idConcesion ?? ""}; Expediente: ${concesionario.numeroExpediente ?? ""}; Placas: ${concesionario.seriePlaca ?? ""}; Observaciones: ${observaciones}; Anualidad: ${anualidad ?? ""};`;
    const { userID } = JSON.parse(localStorage.getItem("usuario"));
    const dataPolizaFinal = {
        IdPolizaPago: 0,
        IdConcesion: concesionario.idConcesion ?? 0,
        FechaVencimiento: vigencia,
        Importe: aPagar,
        IdAreaEmisora: 2,
        IdContribuyente: contribuyente.idContribuyente,
        DatosAdicionales: datosAdicionales,
        LineaCaptura: "",
        IdUsuarioElabora: userID,
        IdPerfil: 0,
        IdSmartCard: 0,
        IdArea: 1,
        IdDireccion: direccion.idDireccion ?? 0
    }

    const settings = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(dataPolizaFinal)
    };

    try {
        const data = await (await fetch("/api/historial/crear", settings)).json();
        return new Promise((resolve, reject) => {
            if (data.status === "Ok") {
                resolve(data.data);
            }
            else reject("Fue imposible crear nueva poliza de pago");
        })
    }
    catch (error) {
        mensajeError(error.message);
    }
}